import { editorComponent } from './editor.component';
import { editorImageUploadModal } from './editor-image-upload-modal/editor-image-upload-modal.module';
import { editorVideoLinkModal } from './editor-video-link-modal/editor-video-link-modal.module';
import { EditorService } from './editor.service';

import './jodit.min.css';
import './editor.scss';

export const editor = angular
	.module('common.components.editor', [
        editorImageUploadModal,
        editorVideoLinkModal
    ])
	.component('editor', editorComponent)
    .service('EditorService',EditorService)
	.name;


// WEBPACK FOOTER //
// ./src/app/common/components/editor/editor.module.js